import { motion } from "framer-motion";

function CareLineCTA({ slug }) {
    const queueHref = slug ? `/${slug}/careline` : "/careline/careline";
    return (
        <section
            className="relative overflow-hidden py-16 md:py-20 font-[Plus_Jakarta_Sans,sans-serif]"
            style={{
                background:
                    "linear-gradient(180deg, #ffffff 0%, #f0fafe 40%, #e8f8fc 70%, #e0f5fb 100%)",
            }}
        >
            <div
                className="absolute inset-0 opacity-[0.025] pointer-events-none z-0"
                style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
                    backgroundRepeat: "repeat",
                    backgroundSize: "128px 128px",
                }}
            />
            <div
                className="absolute -top-32 -left-20 w-[500px] h-[500px] rounded-full pointer-events-none z-0"
                style={{
                    background:
                        "radial-gradient(circle, rgba(6,182,212,0.10) 0%, transparent 70%)",
                }}
            />
            <div
                className="absolute -bottom-40 -right-20 w-[600px] h-[600px] rounded-full pointer-events-none z-0"
                style={{
                    background:
                        "radial-gradient(circle, rgba(8,145,178,0.08) 0%, transparent 70%)",
                }}
            />
            <div
                className="absolute inset-0 pointer-events-none z-0 opacity-[0.06]"
                style={{
                    backgroundImage: `linear-gradient(rgba(6,182,212,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(6,182,212,0.6) 1px, transparent 1px)`,
                    backgroundSize: "60px 60px",
                }}
            />

            <div className="relative z-10 mx-auto max-w-[1280px] px-4 sm:px-6 md:px-10 lg:px-16 xl:px-[60px]">
                <motion.div
                    className="relative flex flex-col md:flex-row items-center justify-between gap-8 rounded-[28px] px-6 sm:px-10 md:px-12 py-10 md:py-12"
                    style={{
                        background:
                            "linear-gradient(135deg, rgba(255,255,255,0.85) 0%, rgba(240,250,255,0.75) 100%)",
                        border: "1px solid rgba(6,182,212,0.18)",
                        boxShadow:
                            "0 0 0 1px rgba(255,255,255,0.9) inset, 0 24px 60px rgba(6,182,212,0.08), 0 4px 16px rgba(6,182,212,0.06)",
                        backdropFilter: "blur(16px)",
                    }}
                    initial={{ opacity: 0, y: 40, scale: 0.98 }}
                    whileInView={{ opacity: 1, y: 0, scale: 1 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{
                        duration: 0.8,
                        ease: [0.25, 0.46, 0.45, 0.94],
                    }}
                >
                    <div
                        className="absolute top-0 left-0 w-40 h-40 pointer-events-none rounded-tl-[28px] overflow-hidden"
                        style={{
                            background:
                                "radial-gradient(circle at 0% 0%, rgba(6,182,212,0.08), transparent 70%)",
                        }}
                    />
                    <div
                        className="absolute bottom-0 right-0 w-40 h-40 pointer-events-none rounded-br-[28px] overflow-hidden"
                        style={{
                            background:
                                "radial-gradient(circle at 100% 100%, rgba(8,145,178,0.07), transparent 70%)",
                        }}
                    />

                    <motion.div
                        className="flex flex-col gap-3 relative text-center md:text-left"
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{
                            duration: 0.7,
                            delay: 0.2,
                            ease: [0.25, 0.46, 0.45, 0.94],
                        }}
                    >
                        <div className="flex items-center gap-2 mb-1 justify-center md:justify-start">
                            <motion.div
                                className="w-1.5 h-1.5 rounded-full"
                                style={{ background: "#06B6D4" }}
                                animate={{
                                    boxShadow: [
                                        "0 0 4px rgba(6,182,212,0.4)",
                                        "0 0 10px rgba(6,182,212,0.8)",
                                        "0 0 4px rgba(6,182,212,0.4)",
                                    ],
                                }}
                                transition={{
                                    duration: 2,
                                    repeat: Infinity,
                                    ease: "easeInOut",
                                }}
                            />
                            <span
                                className="text-[11.5px] font-bold uppercase tracking-widest"
                                style={{ color: "rgba(6,182,212,0.9)" }}
                            >
                                Mulai Sekarang
                            </span>
                        </div>
                        <h2
                            className="text-[clamp(22px,3vw,36px)] font-extrabold leading-tight tracking-[-0.025em]"
                            style={{ color: "#0f172a" }}
                        >
                            Buat{" "}
                            <span
                                style={{
                                    background:
                                        "linear-gradient(90deg, #06B6D4, #0891B2)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                    backgroundClip: "text",
                                }}
                            >
                                Antrian
                            </span>{" "}
                            Anda Hari Ini
                        </h2>
                        <p
                            className="text-[14px] font-medium leading-relaxed max-w-sm mx-auto md:mx-0"
                            style={{ color: "rgba(71,105,130,0.75)" }}
                        >
                            Daftar sekarang dan nikmati kemudahan antrian
                            digital langsung dari genggaman Anda.
                        </p>
                    </motion.div>

                    <motion.div
                        className="flex-shrink-0 relative"
                        initial={{ opacity: 0, x: 20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{
                            duration: 0.7,
                            delay: 0.35,
                            ease: [0.25, 0.46, 0.45, 0.94],
                        }}
                    >
                        <motion.a
                            href={queueHref}
                            className="inline-flex items-center gap-2.5 px-7 sm:px-8 py-3.5 sm:py-4 rounded-full text-white text-[14px] font-bold whitespace-nowrap"
                            style={{
                                background:
                                    "linear-gradient(135deg, #06B6D4 0%, #0891B2 100%)",
                            }}
                            animate={{
                                y: [0, -5, 0],
                                boxShadow: [
                                    "0 8px 24px rgba(6,182,212,0.30)",
                                    "0 16px 32px rgba(6,182,212,0.45)",
                                    "0 8px 24px rgba(6,182,212,0.30)",
                                ],
                            }}
                            transition={{
                                duration: 3,
                                repeat: Infinity,
                                ease: "easeInOut",
                            }}
                            whileHover={{ scale: 1.03 }}
                            whileTap={{ scale: 0.97 }}
                        >
                            Ambil Nomor Antrian
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <line x1="5" y1="12" x2="19" y2="12" />
                                <polyline points="12 5 19 12 12 19" />
                            </svg>
                        </motion.a>
                        <div
                            className="absolute inset-0 rounded-full pointer-events-none"
                            style={{
                                background:
                                    "radial-gradient(ellipse at 50% 120%, rgba(6,182,212,0.18), transparent 70%)",
                                filter: "blur(8px)",
                                transform: "translateY(6px)",
                            }}
                        />
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
}

export default CareLineCTA;